<template>
  <BethsLayout>
    <h1 class="font-bold text-xl">Life Safety at {{ property?.name }}</h1>
    <h2 class="font-bold text-lg py-6">
      Oops, we can't show you this location or it doesn't exist...
    </h2>
    <div class="text-md">
      Sorry, we're not able to show you the VR Floor at this time either because there's been some
      kind of error or because you do not have the correct permissions to be able to view this
      location, or it doesn't exist.
    </div>
    <div class="mt-6">
      <span>
        Please go to your Account settings and verify that you have the correct Building Tenant and
        floor selected or click below to go to your Home Floor.
      </span>
    </div>
    <div class="mt-12">
      <a
        class="py-3 px-2 text-base text-blue-800 hover:bg-blue-500 rounded-t cursor-pointer"
        @click="launchvr"
      >
        Go to VR Home Floor
      </a>
    </div>
  </BethsLayout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";
import router from "../router";
const bldgStore = useBldgStore();
const userStore = useUserStore();

var property = computed(() => bldgStore.property);

function launchvr() {
  console.log("Launching VR");
  if (userStore.isLoggedIn) {
    if (userStore.isEmailVerifiedOrNotRequired) {
      window.open(
        `/api/launch/starttour/${bldgStore.bldgCode}/${userStore.user?.personId}`,
        "_blank"
      );
    } else {
      router.push(`/${bldgStore.siteCode}/unconfirmedemail`);
    }
  } else {
    router.push(`/${bldgStore.bldgCode}/login`);
  }
}
</script>
